// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayoutStyles } from "@rpsc/App/Widgets/Layout/SignInPageLayout";
import IconArrowLeftLink from "@rpsc/XDL/Icons/IconArrowLeftLink";
import { createLinkIconStyles, Divider, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

signInPageLayoutStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 100%;
        flex-direction: row;
        justify-content: center;
        ${({ allowGuestCheckout }: any) => (!allowGuestCheckout ? `margin-top: 36px; ` : null)}

        ${xScreen("lte", "md")} {
            justify-content: start;
            margin-top: 24px;

            ${Divider} {
                margin: 0 20px;
            }
            .creditsDivider {
                width: 100%;
                height: 1px;
                margin: 24px 0;
                flex: 0 0 100%;
            }
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
            padding: 0;

            ${Divider} {
                width: 100%;
                height: 1px;
                margin: 24px 0;

                &.creditsDivider {
                    flex: none;
                }
            }
        }
    `,
};

signInPageLayoutStyles.signInSection = {
    css: css`
        flex: 1;
        max-width: 390px;
    `,
};

signInPageLayoutStyles.createAccountSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            max-width: none;
        }
    `,
};

signInPageLayoutStyles.applyForCreditSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            flex: 0 0 100%;
            max-width: none;
        }
    `,
};

signInPageLayoutStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

signInPageLayoutStyles.checkoutWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 12px;
    `,
};

signInPageLayoutStyles.checkoutTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};

signInPageLayoutStyles.backToCartLink = {
    ...createLinkIconStyles(IconArrowLeftLink, {
        icon: {
            iconProps: {
                size: 11,
                css: css`
                    &,
                    & > svg {
                        height: 13px;
                    }
                `,
            },
        },
    }),
};
